import { Component, OnInit, HostBinding, ViewChild, ElementRef, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';
import { ILayerAttributeSubView } from '../layer-attribute-view/layer-attribute-view.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { DisplayAction } from 'src/app/model/map-actions/display-actions';
import { ViewStackComponent } from '../view-stack/view-stack.component';
import { ControlledVocabApiService } from 'src/app/model/api-services/controlled-vocab-api.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { KVPair, Value, ValList, KVPairList } from 'src/app/types/kv';
import { KvPairListStringPipe } from 'src/app/model/pipes/kv-pair-list-string.pipe';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { DragulaService } from 'ng2-dragula';
import { pairs } from 'd3';


export interface VocabularyPreferences {
  useTypeAhead: boolean;
  limitToExisting: boolean;
  managedVocab: {
    type: 'ValList' | 'KVPairList' | 'none';
    vocab?: ValList | KVPairList;
    id?: number;
  }
  labelMapping: {
    labelAttribute?: '__meta__' | '__none__' | string;
    display: 'label' | 'value' | 'both';
  }
}

export interface VocabularySettings {
  layerId: string;
  attribute: string;
  preferences: VocabularyPreferences;
}

@Component({
  selector: 'app-att-vocab-view',
  templateUrl: './att-vocab-view.component.html',
  styleUrls: ['./att-vocab-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class AttVocabViewComponent implements OnInit, ILayerAttributeSubView {
  public tabViewHeight: '0px';
  @HostBinding('style.att-vocab-view') myStyle = true;
  @HostBinding('style.height')
  public height = 'fit-content';
  @HostBinding('style.max-height') maxHeight = 'fit-content';
  @ViewChild('mainViews') mainViews: ViewStackComponent;
  @ViewChild('managedViews') managedViews: ViewStackComponent;
  @ViewChild('fieldSelector') fieldSelector: ElementRef<HTMLSelectElement>;
  @ViewChild('valuesInput') valuesInput: ElementRef<HTMLTextAreaElement>;
  public name = 'Vocab for: '
  public activeTab = 'text-view';
  public activeTabChange = new EventEmitter<string>();
  public set managedTab(newTabId: string) {
    this.activeTab = newTabId;
    this.activeTabChange.emit(this.activeTab);
  }
  public showManagedDisabled = false;
  public attributeName = '';
  public useTypeAhead = true;
  public limitToExisting = true;
  public serverMenuOpen = false;
  public localMenuOpen = false;
  public openMultiKeyMenu: KVPair | Value = null;

  public get autoBotVis(): boolean {
    if (this.rankedVocab) return false;
    if (!this.mainViews) return false;
    if (this.mainViews.currentView!.viewName !== 'managed') return false;
    return true;
  }

  private _useManaged = false;
  public get useManaged(): boolean {
    return this._useManaged;
  }
  public set useManaged(managed: boolean) {
    $('.show-managed-button').toggleClass('disabled', managed === false);
    this._useManaged = managed;

    this.showManagedDisabled = this._useManaged === false;
    this.useManagedChange.emit(this.useManaged);
  }
  public useManagedChange = new EventEmitter<boolean>();



  public mappingAttribute = '__none__';
  public mapToLabel = 'Labels are stored in:';
  public rankedVocab = false;
  public itemDelimiter = ',';
  public labelDelimiter = ':';
  public hasLabeledValues = true;
  public iHold: 'label' | 'value' = 'value';
  public iShow: 'label' | 'value' | 'both' = 'value';
  public showWhich: 'both' | 'value' | 'label' = 'label';
  public uniqueValues: KVPairList | ValList = []
  public valuesReady = false;
  private layer: SLLayer;
  private attribute: any;
  private _ready = false;
  public get editingVocabList() {
    if (this.mainViews?.currentView?.viewName !== 'managed') return false;
    return (this.managedViews?.currentView?.viewName == 'list')
  }
  public get viewName(): string {
    if (!(this.mainViews && this.mainViews.currentView && this.mainViews.viewName)) {
      return '';
    }
    return this.mainViews.currentView.viewName;
  }

  private _requireLabelMapping = false;
  public get requireLabelMapping(): boolean {
    return this._requireLabelMapping;
  }
  public set requireLabelMapping(isOn: boolean) {
    this._requireLabelMapping = isOn;
    this.domNode.nativeElement.classList.toggle('is-label-mapping', this._requireLabelMapping);
    this.Refresh();
  }

  constructor(private vocabs: ControlledVocabApiService,
    private messager: ModalMessagerService,
    private domNode: ElementRef<HTMLElement>,
    private dragula: DragulaService,
    private cdr: ChangeDetectorRef) {

  }
  ngOnInit(): void {
    this.dragula.createGroup('VALUES', {
      moves: function (el, container, handle) {
        return handle.classList.contains('grip');
      }
    })
    this._ready = true;
  }
  @HostListener('document:click', ['$event'])
  public HandleDocumentClick(event: MouseEvent) {
    if (!this.domNode.nativeElement.contains(event.target as Node)) {
      this.CloseMenus();
    }
  }
  public ToggleServerMenu(event: Event) {
    event.stopPropagation();
    this.serverMenuOpen = !this.serverMenuOpen;
    if (this.serverMenuOpen) this.localMenuOpen = false;
    this.Refresh();
  }
  public ToggleLocalMenu(event: Event) {
    event.stopPropagation();
    this.localMenuOpen = !this.localMenuOpen;
    if (this.localMenuOpen) this.serverMenuOpen = false;
    this.Refresh();
  }
  public ToggleMultiKeyMenu(pair: KVPair | Value, event: Event) {
    event.stopPropagation();
    this.openMultiKeyMenu = this.openMultiKeyMenu === pair ? null : pair;
    this.Refresh();
  }
  public CloseMenus() {
    this.serverMenuOpen = false;
    this.localMenuOpen = false;
    this.openMultiKeyMenu = null;
    this.Refresh();
  }
  Clear() {
    this.requireLabelMapping = false;
    this.mappingAttribute = '__none__';
    this.mapToLabel = 'Labels are stored in:';
    this.rankedVocab = false;
    this.itemDelimiter = ',';
    this.labelDelimiter = ':';
    this.hasLabeledValues = true;
    this.iHold = 'value';
    this.iShow = 'value';
    this.showWhich = 'label';
    this.uniqueValues = []
    this.Refresh();
  }
  SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
    this.layer = layer;
    this.attribute = attribute;
    this.Clear();
    this.name = 'Vocab for: ' + attribute.display;
    this.attributeName = attribute.name;
    this.hasLabeledValues = false;
    this.requireLabelMapping = false;
    if (!!attribute.vocab) {
      this.useManaged = !!attribute.vocab.managedVocab.id;
      if (!!attribute.vocab.labelMapping) {
        if (attribute.vocab.labelMapping.labelAttribute !== '__none__') {
          this.hasLabeledValues = true;
          this.requireLabelMapping = true;
        }
      }
      if (this.hasLabeledValues) {
        this.showWhich = attribute.vocab.labelMapping.display;
        this.mappingAttribute = attribute.vocab.labelMapping.labelAttribute;
      }

    }
    this.UpdateMapTo(this.iHold);
    this.LoadVocabulary();
    this.FillFieldSelector();

  }
  FillFieldSelector() {
    const selectOption = '<option value="__none__">Select an attribute to map to</option>';
    const metadataOption = '<option value="__meta__">Metadata: use data from managed vocab</option>';
    // const createOption = '<option value="__create__">Create a new attribute</option>';
    $(this.fieldSelector.nativeElement).empty();
    $(this.fieldSelector.nativeElement).append($(metadataOption));
    // $(this.fieldSelector.nativeElement).append($(createOption));
    if (this.layer.layerAttributes.length > 1) {
      $(this.fieldSelector.nativeElement).append($(selectOption));

      for (const att of this.layer.layerAttributes) {
        if (this.attribute.name === att.name) {
          continue;
        };
        const option = '<option value="' + att.name + '">' + att.name + '</option>';
        $(this.fieldSelector.nativeElement).append($(option));
      }
    }
    this.Refresh();
  }
  LoadVocabulary() {
    this.valuesReady = false;
    this.vocabs.GetVocab(+this.layer.id, this.attribute.name, (response) => {
      // this.SetVocabulary(response.vocab as VocabularySettings);
      if (!!response.vocab.vocab) {
        this.uniqueValues = response.vocab.vocab;
        this.hasLabeledValues = response.vocab.type === 'KVPairList';
      } else {
        this.uniqueValues = [];
      }
      this.UpdateViewsInput();
      this.HandleManagedView();
      this.Refresh();

    }, (problem) => {
      problem = problem;
    });

  }
  RequestImport() {
    this.CloseMenus();
    this.messager.RequestImport(
      {
        acceptedExtentions: ['slvocab'],
        readType: 'text'
      }, 'Select a SimpleLayers Vocabulary (.slvocab) file to import', (data) => {
        const vocabSettings: VocabularySettings = JSON.parse(data.contents) as VocabularySettings;
        this.SetVocabulary(vocabSettings);
      }, (problem) => {
        problem = problem;
      }, 'Vocabulary Import'
    );
    this.Refresh();

  }
  SetVocabulary(vocabSettings: VocabularySettings) {

    this.uniqueValues = [];
    this.requireLabelMapping = false;
    this.hasLabeledValues = this.requireLabelMapping;
    this.mappingAttribute = '__none__';
    this.useManaged = false;
    this.useTypeAhead = false;
    this.limitToExisting = false;
    if (!!vocabSettings) {
      const preferences = vocabSettings.preferences;
      if (!!preferences.managedVocab) {
        this.useManaged = true;
        if (!!preferences.managedVocab.id) {
          this.LoadVocabulary();
        } else {
          this.uniqueValues = preferences.managedVocab.vocab;
          this.UpdateViewsInput();
        }

      }
      this.requireLabelMapping = preferences.labelMapping.labelAttribute !== '__none__';
      if (!!preferences.labelMapping.labelAttribute) {
        this.mappingAttribute = preferences.labelMapping.labelAttribute;
        this.iShow = preferences.labelMapping.display;
      }
      if (!!preferences.useTypeAhead) {
        this.useTypeAhead = preferences.useTypeAhead;
      }
      if (!!preferences.limitToExisting) {
        this.limitToExisting = preferences.limitToExisting;
      }
    } else {
      this.useManaged = false;

      this.uniqueValues = [];
      this.UpdateViewsInput();
      this.requireLabelMapping = false;
      this.mappingAttribute = '__none__';
      this.iShow = 'label';
      this.useTypeAhead = false;
      this.limitToExisting = false;

    }
    this.hasLabeledValues = this.requireLabelMapping;
    this.managedViews.SetView('list-view');
    this.activeTab = 'list-view';

    this.SetReady();
    // this.HandleManagedView();
    this.Refresh();
  }
  RequestExport() {
    this.CloseMenus();
    if (this.mainViews.currentView.viewName === 'managed') {
      const vocabulary = this.GetVocabSettings();

      this.messager.RequestExport(
        {
          extension: 'slvocab',
          contents: JSON.stringify(vocabulary),
          mimeType: 'text/json',
          defaultFileName: 'vocab-' + this.attributeName
        },
        'Save the current vocabulary locally',
        (response: any) => {
          response = response;
        }, () => {

        }, 'Vocabulary Export'
      );

    }
  }
  GetVocabSettings(): VocabularySettings {
    const vocabType: 'none' | 'KVPairList' | 'ValList' = ((this.useManaged === false) ? 'none' : ((this.requireLabelMapping === true) ? 'KVPairList' : 'ValList'));
    this.ParseInput();
    let vocab: any = this.uniqueValues;

    const vocabulary: VocabularySettings = {
      attribute: this.attribute.name,
      layerId: this.layer.id,
      preferences: {
        useTypeAhead: this.useTypeAhead,
        limitToExisting: this.limitToExisting,
        labelMapping: {
          labelAttribute: (this.requireLabelMapping) ? this.mappingAttribute : '__none__',
          display: this.iShow

        },
        managedVocab: {
          type: vocabType,
          vocab: this.uniqueValues
        }
      }
    };
    return vocabulary;
  }
  ParseInput(): Array<KVPair | Value> {
    const text = this.valuesInput.nativeElement.value;
    const items = text.split(this.itemDelimiter);
    const data = [];
    if (items.length === 0) {
      return [];
    }
    for (let i = 0, len = items.length; i < len; i++) {
      const dataItem: Value = { v: ('' + items[i]).trim() };
      if (this.labelDelimiter !== '') {
        if (items[i].indexOf(this.labelDelimiter) > -1) {
          const subData = items[i].split(this.labelDelimiter);
          if (subData.length === 0) {
            continue;
          }
          if (subData.length === 2) {
            dataItem.v = subData[1];
            (dataItem as KVPair).k = subData[0];
          } else {
            dataItem.v = subData[0];
          }
          data.push(dataItem);
          continue;
        }

      }

      data.push(dataItem);

    }
    if (!!data) {
      this.uniqueValues = data;
    } else {
      this.uniqueValues = [];
    }
    this.HandleManagedView();
  }
  AutoBotRetrieve(mode: 'labels' | 'values') {
    mode = mode;
    this.uniqueValues = [];
    this.valuesReady = false;
    this.Refresh();
    const labelAtt = (['__create__', '__metadta__', '__none__'].indexOf(this.mappingAttribute) === -1) ? this.mappingAttribute : null;
    this.vocabs.GetUnique(this.layer.id, this.attribute.name, labelAtt, (response) => {
      this.uniqueValues = response.results;
      this.UpdateViewsInput();
      this.ParseInput();

      this.SetReady();
      this.HandleManagedView();
      this.Refresh();
    }, (problem) => {
      this.messager.Notify(problem.message, true, 'Problem computing vocabulary');
    });
  }
  UpdateViewsInput() {
    this.valuesInput.nativeElement.value = new KvPairListStringPipe().transform(this.uniqueValues, this.itemDelimiter, this.labelDelimiter);
    this.valuesInput.nativeElement.classList.toggle('hidden', this.valuesReady === false);
  }
  ToggleTypeAhead(useTypeAhead: boolean) {
    if (this.useTypeAhead !== useTypeAhead) {
      this.useTypeAhead = useTypeAhead;
    }
    this.Refresh();
  }
  ToggleExistingLimit(isLimited: boolean) {
    if (this.limitToExisting !== isLimited) {
      this.limitToExisting = isLimited;
    }
    this.Refresh();
  }
  ToggleManaged(isManaged: boolean) {
    if (this.useManaged !== isManaged) {
      this.useManaged = isManaged;

    }
    this.Refresh();
  }
  ShowManaged() {
    let view: string;
    if (this.uniqueValues.length === 0) {
      view = 'text-view';
    } else {
      view = 'list-view';
    }
    this.managedTab = view;
    this.managedViews.SetView(view);
    this.mainViews.SetView('managed');
    this.Refresh();
  }
  ToggleLabelMapping(isRequired: boolean) {
    if (this.requireLabelMapping !== isRequired) {
      this.requireLabelMapping = isRequired;
    }
    this.hasLabeledValues = this.requireLabelMapping;
    this.Refresh();
  }
  UpdateMapTo(which: 'label' | 'value') {
    which = which;
    /*
    switch (which) {
      case 'label':
        this.mapToLabel = 'Field holding values';
        break;
      case 'value':
        this.mapToLabel = 'Field holding labels';
        break;
    }
    this.iHold = which;
    */

  }
  IShowChangeTarget(change: Event) {
    const target = change.target as HTMLInputElement;
    if (target.value) this.IShow(target.value as 'label' | 'value' | 'both');
  }
  IShow(which: 'label' | 'value' | 'both') {
    this.iShow = which;
    this.Refresh();
  }
  HandleTab(whichTab: string | 'text-view' | 'list-view') {
    this.valuesReady = false;
    this.Refresh();
    this.managedViews.SetView(whichTab);
    switch (whichTab) {
      case 'text-view':
        this.UpdateViewsInput();
        break;
      case 'list-view':
        this.ParseInput();
        break;
    }
    window.requestAnimationFrame(() => {
      this.SetReady();
      this.Refresh();
    })
  }
  ToggleHasLabeledValues(isLabeled: boolean) {
    if (this.hasLabeledValues !== isLabeled) {
      this.hasLabeledValues = isLabeled;
    }
    this.Refresh();
  }
  Back() {
    if (this.mainViews.currentView.viewName === 'managed') {
      this.mainViews.SetView('general');
    } else {
      this.UpdateAttribute();
      DisplayAction.SetPrimaryView('layer-attribute-view');
    }
    this.Refresh();
  }
  UpdateAttribute() {
    if (this.attribute.vocab) {
      this.attribute.vocab.limitToExisting = this.limitToExisting;
      this.attribute.vocab.useTypeAhead = this.useTypeAhead;
      this.attribute.vocab.labelMapping = {
        labelAttribute: (this.requireLabelMapping) ? this.mappingAttribute : '__none__',
        display: this.iShow
      }
    }
    this.Refresh();
  }
  public UpdateHeight(primaryHeight: number, panelMax: number) {
    primaryHeight = primaryHeight;
    this.height = panelMax + 'px';
    this.maxHeight = panelMax + 'px';
    this.domNode.nativeElement.style.setProperty('--panel-height', panelMax / 16 + 'rem');
    this.Refresh();
  }
  public RemoveKeyVal(pv: KVPair | Value) {
    if (this.openMultiKeyMenu === pv) {
      this.openMultiKeyMenu = null;
    }
    const pair = pv as KVPair;
    const index: number = this.uniqueValues.indexOf(pair);
    this.uniqueValues.splice(index, 1);
    this.uniqueValues = this.uniqueValues;
    this.Refresh();
  }
  public IsMultiKey(pair: KVPair | Value): boolean {
    if (!pair.hasOwnProperty('k')) {
      return false;
    }
    if ((pair as KVPair).k === null) {
      return false;
    }
    if (typeof (pair as KVPair).k === 'string') {
      return false;
    }
    return (pair as KVPair).k.length > 1;
  }
  public GetFirstKey(pair: KVPair | Value): any {

    if (!(pair as KVPair).k) {
      return '';
    }
    if ((pair as KVPair).k === null) {
      return '';
    }
    if (typeof (pair as KVPair).k === 'string') {
      return (pair as KVPair).k;
    }

    if ((pair as KVPair).k.length === 0) {
      return '';
    }
    return (pair as KVPair).k[0];
  }
  DelimiterUpdated() {
    this.UpdateViewsInput();
    this.Refresh();
  }
  SetReady() {
    this.valuesReady = true;
    this.Refresh();
  }
  AddItem() {
    if (this.hasLabeledValues === true) {
      (this.uniqueValues as KVPairList).push({ k: '', v: '' });
    } else {
      (this.uniqueValues as ValList).push({ v: '' });
    }
    this.Refresh();
  }
  Download() {
    this.CloseMenus();
    this.LoadVocabulary();
  }
  Upload() {
    this.CloseMenus();
    const vocabSettings = this.GetVocabSettings();

    this.vocabs.SaveVocab(vocabSettings, (response) => {
      this.attribute.vocab = vocabSettings.preferences;
      if (!!response.vocabId) {
        this.attribute.vocab.managedVocab.id = response.vocabId;
      }
      if (!!this.attribute.vocab.managedVocab.vocab) {
        delete (this.attribute.vocab.managedVocab.vocab);

      }
    });
  }
  GetPairKeys(p: KVPair | Value): Array<string> {
    const pair = p as KVPair;
    if (!pair.k) return [];
    return pair.k;
  }
  UpdateKey(p: KVPair | Value, e: any) {
    (p as KVPair).k = e.target.value as string;
    this.UpdateViewsInput();

  }
  HandleManagedView(_view?: any) {
    this.valuesReady = false;
    this.Refresh();
    this.valuesReady = true;
    this.Refresh();
  }
  Refresh() {
    if (this._ready) this.cdr.detectChanges();
  }
}
